// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/eval-testing/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/eval-testing/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Không classify được" })
  return <Page />
}
